<mat-form-field appearance="outline" fxFlex="100%">
    <mat-label>
        <ng-content></ng-content>
    </mat-label>
    <input matInput autocomplete="off" readonly [value]="value" />
</mat-form-field>